module.exports = __webpack_public_path__ + "static/dispos1-a67163ea8f106ed3141ad973365e7c9e.png";